<template>
    <PageFrameContainer>

        <div class="feature-panel-container">
            <input :id="id" :class="id" type="radio" :value="id" name="features-btn" v-model="selectedId"
                   v-on:click="uncheckIfChecked">
            <label :for="id">
                <div class="header-container">
                    <img :src="require(`../../../../assets/icons/products/${icon}.svg`)" alt="d">
                    <h1>{{title}}</h1>
                    <h2>{{desc}}</h2>
                </div>
            </label>

            <div class="expand">
                <div class="expand-body">
                    <section>
                        <slot></slot>
                    </section>
                </div>
            </div>
        </div>
    </PageFrameContainer>
</template>

<script>
    import PageFrameContainer from "../../../../components/PageFrameContainer";

    let uuid = 1;
    export default {
        name: "FeaturesPageFeaturePanel",
        components: {PageFrameContainer},
        props: ["icon", "title", "desc", "checkedOnLoad"],
        data() {
            return {
                id: null,
                selectedId: null
            }
        },
        mounted() {
            this.id = this.uuid;
            if (this.checkedOnLoad === true) {
                let self = this;
                this.$nextTick(() => self.selectedId = self.id);
                //let checkbox = document.getElementsByClassName(this.id);
                // checkbox.checked = true;
            }
        },
        beforeCreate() {
            this.uuid = uuid.toString();
            uuid += 1;
        },
        methods: {
            uncheckIfChecked() {
                if (this.selectedId === this.id)
                    this.selectedId = null;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../theme/theme";

    .feature-panel-container {
        display: grid;
        margin-top: 0.5em;
        margin-bottom: 0.5em;
        border: 1px solid $text20;
        border-radius: 0.4em;
    }

    .feature-panel-container:hover {
        border: 1px solid $primary80;
    }

    input {
        display: none;
        visibility: hidden;
    }

    label {
        display: grid;
        user-select: none;
    }

    label:hover {
        background: $back40;
    }

    .header-container {
        display: grid;
        grid-template-columns: 10rem auto;
        grid-template-rows: auto auto;
        border-bottom: 1px solid $text20;
        row-gap: 0.5em;
        padding-top: 0.5em;
        padding-bottom: 0.5em;
    }

    .header-container > img {
        grid-column: 1;
        grid-row-start: 1;
        grid-row-end: 3;
        height: 5rem;
        margin: auto;
    }

    .header-container > h1 {
        grid-column: 2;
        grid-row: 1;
        font-weight: 300;
        color: $primary20;
        font-size: 1.8em;
        text-align:justify
    }

    .header-container > h2 {
        grid-column: 2;
        grid-row: 2;
        font-size: 1.0rem;
        font-weight: 300;
        color: $text80;
        margin-right: 1em;
        text-align:justify
    }

    @media (max-width: 40em) {

        .header-container > img {
            grid-column: 1;
            grid-row: 1;
            height: 3rem;
            margin: auto;
        }

        .header-container > h1 {
            grid-column: 2;
            grid-row: 1;
            font-size: 1.6rem;
            padding-right: 1em;
        }

        .header-container > h2 {
            grid-column: 1/3;
            grid-row: 2;
            font-size: 0.8rem;
            padding: 1em;
        }
    }

    input:checked ~ .expand {
        max-height: 90em;
        //padding-bottom: 0.5em;
        //margin-top: 0.5em;
        //padding-right: 0.5em;
        transition: max-height 0.75s;
    }

    .expand {
        overflow: hidden;
        font-weight: 300;
        color: $text80;
        padding-left: 2em;
        margin-left: 1em;
        max-height: 0;
        transition: max-height 0.25s;

        .expand-body {
            padding-bottom: 1em;
            margin-top: 1em;
        }
    }

    /*.expand {
        max-height: 0;
        overflow: hidden;
        padding-left: 2em;
        transition: max-height 0.25s;
        color: $text80;
    }
    .feature-panel-container input:checked ~ .expand {
        height: auto;
        padding-bottom: 1em;
        margin-top: 1em;
        padding-right: 1em;
        transition: height 0.5s;
        margin-left: 1em;
    }*/

</style>